import { Component, ElementRef } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService, LocalizeService } from '../../../insa-services';
import { RegistrationFields } from '../../../insa-models';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';

@Component({
  templateUrl: 'register.component.html',
})
export class RegisterComponent {
  private registrationForm;
  private activationForm: FormGroup;
  private registrationSuccess = false;
  private activationSuccess = false;

  constructor(
    private _authService: AuthService,
    private _router: Router,
    private _localize: LocalizeService,
    private _element: ElementRef
  ) {}

  updateRegistrationState({ isSuccess = false, isError = false } = {}) {
    if (isSuccess) {
      this.registrationSuccess = true;
      this.toggleLoading(false);
    } else if (isError) {
      this.toggleLoading(false);
    } else {
      this.toggleLoading(true);
    }
  }

  updateActivationState({ isSuccess = false, isError = false } = {}) {
    if (isSuccess) {
      this.activationSuccess = true;
      this.toggleLoading(false);
    } else if (isError) {
      this.toggleLoading(false);
    } else {
      this.toggleLoading(true);
    }
  }

  submitRegistrationForm(): void {
    if (this.registrationForm.valid) {
      this.updateRegistrationState();
      this._authService.register(
        this.registrationForm.value as RegistrationFields
      );
    }
  }

  submitActivationForm() {
    if (this.activationForm.valid) {
      this.updateActivationState();
      this._authService.verifyActivationCode(
        this.activationForm.value.activationCode
      );
    }
  }

  toggleLoading(toggle) {
    const loadingEl = $('.main-loading');
    kendo.ui.progress(loadingEl, toggle);

    if (toggle) {
      loadingEl.css('display', 'block');
      // document.body.style.overflowY = "hidden"
    } else {
      loadingEl.css('display', 'none');
      // document.body.style.overflowY = "auto"
    }
  }
  private get activationCode() {
    return this.activationForm.get('activationCode');
  }

  ngOnInit(): void {
    this.registrationForm = new FormGroup(
      {
        username: new FormControl('', [Validators.required]),
        email: new FormControl('', [Validators.required, EmailValidator]),
        password: new FormControl('', [Validators.required]),
        confirmPassword: new FormControl('', [
          Validators.required,
          makeIsEqualToValidator('password'),
        ]),
        fullName: new FormControl('', [Validators.required]),
        street: new FormControl('', [Validators.required]),
        number: new FormControl(null, [Validators.required]),
        city: new FormControl('', [Validators.required]),
        country: new FormControl('', [Validators.required]),
        phone: new FormControl(''),
        fax: new FormControl(''),
        mobile: new FormControl('', [Validators.required]),
        gdprCheckbox: new FormControl('', [Validators.requiredTrue]),
      },
      []
    );

    this.activationForm = new FormGroup({
      activationCode: new FormControl('', [
        Validators.required,
        Validators.minLength(4),
      ]),
    });
  }

  ngAfterViewInit() {
    this._localize.applyTranslations(this._element.nativeElement, 'LOOKUP'); // use the lookup table because translation service might not be available
  }

  // field getters
  private get username() {
    return this.registrationForm.get('username');
  }
  private get email() {
    return this.registrationForm.get('email');
  }
  private get password() {
    return this.registrationForm.get('password');
  }
  private get confirmPassword() {
    return this.registrationForm.get('confirmPassword');
  }
  private get fullName() {
    return this.registrationForm.get('fullName');
  }
  private get street() {
    return this.registrationForm.get('street');
  }
  private get number() {
    return this.registrationForm.get('number');
  }
  private get city() {
    return this.registrationForm.get('city');
  }
  private get country() {
    return this.registrationForm.get('country');
  }
  private get phone() {
    return this.registrationForm.get('phone');
  }
  private get fax() {
    return this.registrationForm.get('fax');
  }
  private get mobile() {
    return this.registrationForm.get('mobile');
  }
}

function EmailValidator(control: AbstractControl) {
  const isValid = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(control.value);
  return isValid ? null : { format: { value: control.value } };
}

function makeIsEqualToValidator(fieldName): ValidatorFn {
  return function isEqualTo(control: FormGroup): ValidationErrors | null {
    const compareField = control.root.get(fieldName);

    return control && compareField && control.value !== compareField.value
      ? { equalTo: true }
      : null;
  };
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-login/registration/register.component.ts